import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { MainContentContext } from './MainContent.context';
import { MainContentBodyStyled } from './MainContentBody.styled';
const MainContentBody = ({ children, ...props }) => {
    const containerContext = useContext(MainContentContext);
    useEffect(() => {
        if (!containerContext) {
            throw new Error('MainContentBody must be used as a child of MainContent component.');
        }
    });
    return (_jsx(MainContentBodyStyled, { ...containerContext, ...props, children: children }));
};
export { MainContentBody };
